module.exports = __webpack_public_path__ + "img/jhonny-nunez-desert.7dabfd8.jpg";